import { render, staticRenderFns } from "./SectorsSidebar.vue?vue&type=template&id=5fbcc108&scoped=true&"
import script from "./SectorsSidebar.vue?vue&type=script&lang=js&"
export * from "./SectorsSidebar.vue?vue&type=script&lang=js&"
import style0 from "./SectorsSidebar.vue?vue&type=style&index=0&id=5fbcc108&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbcc108",
  null
  
)

export default component.exports